import React from 'react';

interface ProgressBarProps {
  progress: number; // 0-100
  color?: 'primary' | 'success' | 'warning' | 'error';
  showLabel?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  color = 'primary',
  showLabel = true,
  size = 'medium',
}) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  const colorClasses = {
    primary: 'bg-kids-primary',
    success: 'bg-kids-success',
    warning: 'bg-kids-warning',
    error: 'bg-kids-error',
  };

  const sizeClasses = {
    small: 'h-2',
    medium: 'h-4',
    large: 'h-6',
  };

  return (
    <div className="w-full">
      <div className={`w-full bg-gray-200 rounded-full overflow-hidden ${sizeClasses[size]}`}>
        <div
          className={`${colorClasses[color]} ${sizeClasses[size]} rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
      {showLabel && (
        <p className="text-center text-gray-600 mt-1 font-bold">
          {Math.round(clampedProgress)}%
        </p>
      )}
    </div>
  );
};

export default ProgressBar;
